// removed by extract-text-webpack-plugin
module.exports = {"busy":"Busy__busy___3Xjoa","enter":"Busy__enter___3uARD","enterActive":"Busy__enterActive___2LYF5","leave":"Busy__leave___3xvZc","leaveActive":"Busy__leaveActive___3GLDv","busyIcon":"Busy__busyIcon___1zEM-","rotate":"Busy__rotate___2-Q-W","message":"Busy__message___2RO5I"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/types/busy/Busy.less
 ** module id = 774
 ** module chunks = 0
 **/